module.exports = __webpack_public_path__ + "ath_game_web/img/2.3.7df5d7f9.png";